import React from 'react'
import Header from './../components/Header'
import { NavLink } from 'react-router-dom'

const ForgotPassword = () => (<div>
  <section className="hero is-blue-gem-2">
    <Header/>
    <div className="hero-body">
      <div className="container has-text-centered">
        <h1 className="title">
          Reset password
        </h1>
      </div>
    </div>
  </section>
  <section className="section">
    <div className="container">
      <div className="columns is-centered">
        <div className="column is-half">
          <div className="box">
            <div className="field">
              <p className="control has-icons-left has-icons-right">
                <input className="input" type="email" placeholder="Email"/>
                <span className="icon is-small is-left">
                  <i className="fas fa-envelope"></i>
                </span>
                <span className="icon is-small is-right">
                  <i className="fas fa-check"></i>
                </span>
              </p>
            </div>
            <div className="field">
              <p className="control">
                <button className="button button is-blue-gem-2 is-fullwidth">
                  Send Password Reset Link
                </button>
              </p>
            </div>
            <div className="field">
              <div className="control">
                <p className="control has-text-centered">
                  Don't have an account? <NavLink to="/register">Get started now!</NavLink>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>)

export default ForgotPassword



// WEBPACK FOOTER //
// ./src/containers/ForgotPassword.js